// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BorderInnerOutlinedSvg from "@ant-design/icons-svg/es/asn/BorderInnerOutlined";
import AntdIcon from '../components/AntdIcon';

var BorderInnerOutlined = function BorderInnerOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BorderInnerOutlinedSvg
  }));
};

BorderInnerOutlined.displayName = 'BorderInnerOutlined';
export default React.forwardRef(BorderInnerOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/BorderInnerOutlined.js
// module id = 659
// module chunks = 0